import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/core';
import {
  Breadcrumb,
  BreadcrumbService,
  HeaderData
} from 'src/app/core/services/breadcrumb.service';
import { LoggingService } from 'src/app/core/services/logging.service';
import { AccessManegerService } from 'src/app/views/access-manager/access-manager.service';
import { DashboardService } from 'src/app/views/dashboard/dashboard.service';
import { ProfileViewComponent } from '../../components/profile-view/profile-view.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  name = 'User';
  isShow!: boolean;
  profileData: {
    adminRoles?: Array<string>;
    email?: string;
    isActive?: boolean;
    userName?: string;
  } = {};

  breadcrumbs$?: Observable<Breadcrumb[]>;
  headerData$?: Observable<HeaderData>;
  isEmbeddedView = false;

  private readonly destroyRef = inject(DestroyRef);
  private readonly logger = inject(LoggingService);

  constructor(
    public readonly dialog: MatDialog,
    private readonly dashboardService: DashboardService,
    private readonly profileService: AccessManegerService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly appService: AppService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
    this.headerData$ = this.breadcrumbService.headerData$;

    this.appService.isEmbeddedViewasObservable
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((bool) => {
        this.isEmbeddedView = bool;
      });

    this.profileService
      .getProfileDetail()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        this.profileData = response;
        this.name = this.profileData.userName ?? '';
      });

    this.dashboardService.isHome
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.isShow = res;
      });
  }

  viewProfile(): void {
    this.dialog.open(ProfileViewComponent, {
      data: { ...this.profileData },
      width: '450px',
      panelClass: 'custom-dialog'
    });
  }

  navigate(url: string): void {
    this.router
      .navigateByUrl(url)
      .catch((e: unknown) => this.logger.error('Navigation failed', e));
  }

  getNumber(value: Breadcrumb[] | undefined): number {
    return value?.length ?? 0;
  }
}
